<template>
  <v-container fluid>
    <div class="dashboard-page">
      <!-- Carousel -->
       <v-row v-if="listPromo.length">
        <v-col cols="12">
          <div>
            <v-carousel
              cycle
              height="350"
              hide-delimiter-background
              show-arrows-on-hover
              style="border-radius: 8px;"
            >
              <v-carousel-item
                v-for="(item, i) in listPromo"
                :key="i"
              >
                <v-sheet
                >
                  <v-img
                    :lazy-src="`data:image/png;base64,${item.carrouselImage}`"
                    max-width="100%"
                    max-height="100%"
                    contain
                  ></v-img>
                </v-sheet>
              </v-carousel-item>
            </v-carousel>
          </div>
        </v-col>
       </v-row>
      <!-- Point -->
      <v-row>
        <v-col cols="12">
          <div class="points d-flex justify-space-between">
            <div class="pointDtl">
              <v-img
                max-height="40"
                max-width="40"
                src="@/assets/icon-color-coin.svg"
              ></v-img>
              <div>
                <p class="text-subtitle-1 ma-0">M - Point</p>
                <p class="totalPoint ma-0 font-weight-bold">{{ this.pointMekappin }}</p>
              </div>
            </div>
            <div class="my-auto">
              <router-link :to="`/${$constant.REWARD}`">
              <v-icon>mdi-chevron-right</v-icon>
            </router-link>
            </div>
          </div>
        </v-col>
      </v-row>
      <!-- List Produk Payment -->
      <v-row>
        <v-col cols="12" class="">
          <products> </products>
        </v-col>
      </v-row>
      <!-- Carousel Produk Reward -->
      <v-row v-if="this.productReward.length > 0">
        <v-col cols="12">
          <div class="section-reward-poin">
            <div class="d-flex justify-space-between">
              <p class="font-weight-medium text-h6 text-md-h5 text-lg-h5 ml-3 my-3 pinkText">
                Reward Poin
              </p>
              <router-link
                :to="`/products/${$constant.REWARD}`"
                class="text-decoration-none"
              >
                <p class="text-right darkGreyText mt-2 mr-5 text-decoration-none font-weight-medium text-h6 text-md-h5 text-lg-h5">Lihat Semua</p>
              </router-link>
            </div>
            <v-sheet
              class="mx-auto"
              elevation="0"
              max-width="100%"
            >
              <v-slide-group
                v-model="model"
                class="pa-4"
                center-active
                v-if="loadingProductReward"
              >
                <v-slide-item
                  v-for="i in 10"
                  :key="i"
                >
                  <CardLoading></CardLoading>
                </v-slide-item>
              </v-slide-group>

              <v-slide-group
                v-model="model"
                class="pa-4"
                center-active
                v-else
              >
                <v-slide-item
                  v-for="product in this.productReward"
                  :key="product.productCode"
                >
                  <router-link
                    :to="`/product/${product.productCode}/${$constant.REWARD}/detail`"
                    class="text-decoration-none"
                  >
                    <Card :product="product" :poin="true"></Card>
                  </router-link>
                </v-slide-item>
              </v-slide-group>
            </v-sheet>
          </div>
        </v-col>
      </v-row>
      <!-- Daftar Transaksi -->
      <v-row>
        <v-col cols="12">
          <div class="daftarTransaksi">
            <div class="d-flex justify-space-between">
              <p class="text-h6 font-weight-bold pinkText" color="$secondary">Daftar Transaksi</p>
              <router-link :to="`/transactions/tab-OS_ALL_TRANS`" class="font-weight-bold text-decoration-none">
                <p class="font-weight-bold text-decoration-none darkGrey" style="color: black;">Lihat Semua</p>
              </router-link>
            </div>
            <div class="d-flex justify-space-between">
              <div>
                <p class="font-weight-bold text-h6">Menunggu Pembayaran</p>
                <p class="" style="margin-top: -13px;">Semua transaksi yang belum dibayarkan</p>
              </div>
              <div>
                {{ this.totalOrderUnpaid }}
              </div>
            </div>
          </div>
        </v-col>
      </v-row>
    </div>
  </v-container>
</template>

<script>
import Products from "@/pages/ProductsDashboard/ProductsDashboard";
import Card from '@/components/Card/Card.vue';
import CardLoading from '@/components/Card/CardLoading.vue';

import { mapActions, mapState } from "vuex";
export default {
  name: "Dashboard",
  components: {
    products: Products,
    Card,
    CardLoading
  },
  data() {
    return {
      listPromo: [],
      totalUnit: "",
      totalKomisi: "",
      totalPremi: "",
      showPopUpNotificationDialog: true,
      totalOrderUnpaid: 0,
      pointMekappin: 0,
      productReward: [],
      model: null,
      loadingProductReward: true,
    };
  },
  methods: {
    ...mapActions([
      "getPromo",
      "changeTitleApp",
      "getListProductReward",
      "refreshToken",
      "getCartList",
      "getTransactions",
      "getProfile"
    ]),
    async loadCartList() {
      this.getCartList({
        by: {
          pageNumber: 1,
          pageSize: 100,
          searchVal: "",
          status: "CIS_NEW",
        },
        isGroupedByStatus: true,
      })
        .then((response) => {
          this.$helpers.handleSuccess(response);
        })
        .catch((error) => {
          this.$helpers.handleError(error);
        });
    },
    loadTransaction(){
      this.getTransactions({
        pageNumber: 1,
        pageSize: 10,
        searchVal: "",
        status: "OS_UNPAID",
      }).then((response) => {
        this.totalOrderUnpaid = response.data.data.totalData;
      });
    },
    loadPoint(){
      this.getProfile().then((resp) => {
        this.pointMekappin = resp.data.data.poin;
      });
    },
    async getProductsRewardList(){
      await this.getListProductReward({
        pageSize: 10,
        pageNumber: 1,
        productPartnerRequestList: [],
        sort: ""
      }).then((response) => {
        this.productReward = response.data.data.content;
        this.loadingProductReward = false;
      })
    },
    async loadImgPromo(){
      await this.getPromo()
      .then((response) => {
        this.listPromo = response.data.data;
      })
    }
  },
  created() {
    this.changeTitleApp("Beranda");
  },
  computed: {
    ...mapState(["vaInfo", "popupNotif", "popupNotifById", "features"]),
  },
  mounted() {
    this.loadImgPromo();
    this.loadTransaction();
    this.loadPoint();
    this.getProductsRewardList();
  },
};
</script>

<style scoped src="./Dashboard.scss" lang="scss" />
